<template>
  <div style="width: 100%; height: 100%">
    <div
      class="tab"
      v-show="$route.meta.tabMenu == undefined || $route.meta.tabMenu"
    >
      <i class="search_btn" @click="jumpDown"></i>
      <div @click="checkTab(0)">
        <router-link
          :class="{ active: tabIndex === 0 }"
          :to="{ name: 'Find' }"
          tag="li"
          >晒照</router-link
        ><span :class="{ line: tabIndex === 0 }"></span>
      </div>
      <div @click="checkTab(1)">
        <router-link
          :class="{ active: tabIndex === 1 }"
          :to="{ name: 'Ask' }"
          tag="li"
          >问吧</router-link
        ><span :class="{ line: tabIndex === 1 }"></span>
      </div>
      <!-- <div @click="checkTab(2)"><router-link :class="{active: tabIndex === 2}" :to="{name: 'Active'}" tag="li">活动</router-link><span :class="{line: tabIndex === 2}"></span></div> -->
    </div>
    <!-- 路由出口 -->
    <router-view></router-view>
  </div>
</template>

<script>
import { navigate } from "@/pages/index/custom";
import Contents from "@/request/base.default.js";
export default {
  data() {
    return {
      tabIndex: 1,
    };
  },
  methods: {
    // 选项卡切换
    checkTab(index) {
      this.tabIndex = index;
    },
    jumpDown() {
      window.localStorage.setItem("h5_index_search_focus", 1);
      navigate("", Contents.mainURL + "/app/index/search");
    },
  },
  created() {
    let { name } = this.$route;
    switch (name) {
      case "Find":
        this.tabIndex = 0;
        break;
      case "Ask":
        this.tabIndex = 1;
        break;
      // case "Active": this.tabIndex = 2
      // break;
      default:
        this.tabIndex = 1;
        break;
    }
  },
};
</script>

<style lang="less" scoped>
.search_btn {
  position: absolute;
  top: 50%;
  left: 20px;
  width: 24px;
  height: 24px;
  margin-top: -12px;
  background: url(../../../../assets/img/icon_search.png) no-repeat;
  background-size: 100% 100%;
}
.tab {
  position: fixed;
  top: 0;
  left: unset;
  max-width: 648px;
  background-color: #fff;
  height: 3.75rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  z-index: 2333;
}
.tab > div {
  position: relative;
  margin: 0 12px;
}
.tab li {
  font-size: 16px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  height: 100%;
  line-height: 3.75rem;
  transition: all 0.3s;
  list-style: none;
}
.tab li.active {
  font-size: 24px;
  font-weight: 600;
}
.tab .line {
  position: absolute;
  bottom: 8px;
  left: 50%;
  margin-left: -10px;
  width: 1.25rem;
  height: 0.25rem;
  background-color: #ff4c67;
  box-shadow: 0px 2px 6px 0px #fd7c90;
  border-radius: 10px;
}
</style>